<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="serverError === null">
  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-hover table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; padding-top: 8px; padding-bottom: 8px;">
          <div class="float-right">
            <button class="btn btn-sm btn-outline-primary mr-1"
                    style="font-size: 12px; line-height: 12px;"
                    [class.disabled]="loadingPasses"
                    [disabled]="loadingPasses"
                    (click)="openAddPassModal()">
              Add Manual Pass
            </button>
            <button class="btn btn-sm btn-outline-primary"
                    style="font-size: 12px; line-height: 12px;"
                    [class.disabled]="loadingPasses"
                    [disabled]="loadingPasses"
                    (click)="openPurchasePassModal()">
              Purchase Entry Pass
            </button>
          </div>
          <span style="position: relative; top: 4px;">Association Entry Passes</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Pass Name</th>
        <th scope="col">Manager</th>
        <th scope="col">Purchase Date</th>
        <th scope="col">Balance</th>
        <th scope="col">Expiration Date</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingPasses">
      <tr *ngFor="let entryPass of passList.results"
          [class.font-italic]="entryPass.number_of_uses_remaining <= 0">
        <td class="pass-name-cell">
          {{ entryPass.name }}
          <span class="d-block mt-2"></span>
          <span class="pass-name-secondary d-block"
                *ngFor="let passCustomer of entryPass.all_customers">
            {{ passCustomer.first_name }} {{ passCustomer.last_name }}
            <span class="text-secondary ml-1">Linked</span>
          </span>
          <span class="pass-name-secondary d-block"
                *ngFor="let passUnlinkedCustomer of entryPass.unlinked_customers">
            {{ passUnlinkedCustomer.first_name }} {{ passUnlinkedCustomer.last_name }}
            <ng-container *ngIf="loadingUnlinkedEntryPassCustomer[passUnlinkedCustomer.id]">
              (<span class="text-muted">Loading...</span>)
            </ng-container>
            <ng-container *ngIf="!loadingUnlinkedEntryPassCustomer[passUnlinkedCustomer.id]">
              (<a href="#" (click)="openLinkUnlinkedEntryPassCustomerModal(passUnlinkedCustomer);$event.preventDefault();">Pending</a>)
            </ng-container>
            <span class="text-secondary ml-1">Linked</span>
          </span>
          <span class="pass-name-secondary d-block text-secondary"
                *ngIf="(entryPass.all_customers.length + entryPass.unlinked_customers.length) === 0">
            No Linked Customers
          </span>
        </td>
        <td>
          <a [routerLink]="['/customers', entryPass.owner_id.toString(), 'memberships-and-passes']">
            {{ entryPass.owner_first_name }} {{ entryPass.owner_last_name }}
          </a>
        </td>
        <td>{{ dateStringFromISO8601(entryPass.created_date) }}</td>
        <td>
          <span *ngIf="entryPass.status === CustomerEntryPassStatus.removed"
                class="text-danger">
            Removed
          </span>
          <span>
            {{ entryPass.number_of_uses_remaining }} /
            {{ entryPass.number_of_uses_total }} Entries
          </span>
        </td>
        <td>
          <span *ngIf="!entryPass.expiration_date" class="text-muted">None</span>
          <span *ngIf="entryPass.expiration_date" [class.text-danger]="entryPass.status === CustomerEntryPassStatus.expired">
            <span *ngIf="entryPass.status === CustomerEntryPassStatus.expired">Expired</span>
            {{ dateStringFromISO8601(entryPass.expiration_date) }}
          </span>
        </td>
        <!-- Set width manually to prevent buttons from wrapping -->
        <td class="table-12px-button-cell" style="width: 108px;">
          <button class="btn btn-sm btn-secondary table-12px-button float-right"
                  (click)="editEntryPass(entryPass)">
            Edit
          </button>
          <button class="btn btn-sm btn-secondary table-12px-button float-right mr-1"
                  (click)="linkEntryPass(entryPass)">
            Link
          </button>
        </td>
      </tr>
      <tr *ngIf="passList.results.length === 0">
        <td colspan="99" class="text-muted">No entry passes</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingPasses">
      <tr>
        <td colspan="99" class="text-muted">Loading entry passes...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSizeAssociationEntryPassesSubList" (change)="setPage(1)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
